import { IStyles, IClasses } from '../index'
import { IDefaultStyle } from '../schemamanager/types'

export const c = (classes: IClasses): IStyles => {
    return {
        classes
    }
}

// export const mainCompStyles = (comp: IComponent): IStyles => {
//     const ret: IStyles = {}
//     if (comp.className) ret.className = comp.className
//     if (comp.classes) ret.classes = comp.classes
//     if (comp.style) ret.style = comp.style
//     return ret
// }
interface IDefaultStyleKey {
    styleChildren: IDefaultStyle
}
export const defStyleChildren = (): IDefaultStyleKey => {
    return {
        styleChildren: {
            classes: {
                padding: 'px-8 py-5'
            }
        }
    }


}
